
import { useShare } from "@vueuse/core";

export default {
  props: ["article"],
  name: "blog",
  computed:{
    html(){
      if (this.article.html) {
        return this.article.html.replace(
          /https:\/\/(static\.pharmacy295|295static\.pharmacy295|295static\.shopster)[^"'\s)]+/g,
          (url) => this.$hyperUtility.imgproxy(url, 750)
        );
      }
      return this.article.html;
    }
  },
  head() {
    return {
      title: `${
        (this.article || {}).title_tag || (this.article || {}).title || ""
      } - 295 blog`,
      meta: [
        {
          hid: "description",
          name: "description",
          content: (this.article || {}).meta_description || this.article.short,
        },
        {
          hid: "og:title",
          property: "og:title",
          content: this.article.title,
        },
        {
          hid: "og:type",
          property: "og:type",
          content: "article",
        },
        {
          hid: "og:url",
          property: "og:url",
          content: `https://${this.$store.getters.host}${this.$route.path}`,
        },
        {
          hid: "og:description",
          property: "og:description",
          content: this.article.short,
        },
        {
          hid: "og:image",
          property: "og:image",
          content: this.article.headerMedia,
        },
        {
          hid: "og:image:secure_url",
          property: "og:image:secure_url",
          content: this.article.headerMedia,
        },
        {
          hid: "og:image:alt",
          property: "og:image:alt",
          content: this.article.title,
        },
      ],
    };
  },
  data() {
    return {
      contents: [],
      activeContent: "",
      more: [],
      msg: "",
      next: { url: "", title: "1", ready: false },
      previous: { url: "", title: "2", ready: false },
      relatedProducts: [],
    };
  },
  async mounted() {
    if (process.browser) {
      let art = document.querySelector(".the-article");
      if (art) {
        let h2s = art.querySelectorAll("h2,h3");
        let contents = [];
        h2s.forEach((h2, index) => {
          h2.classList.add(`h2${index}`);
          contents.push(h2.innerText);
        });
        this.contents = contents;
      }
      this.getAdjacent(this.article._id);
      this.getRelatedProducts();
    }
    this.more = await this.$hyperBlog.getArticles(
      "category",
      this.article.category,
      3
    );
  },
  methods: {
    share() {
      const { share, isSupported } = useShare();
      share({
        title: this.article.title,
        text: this.article.short,
        url: location.href,
      });
    },
    async getRelatedProducts() {
      if (!this.article.products) {
        return;
      }
      console.log(this.article.products, this.article.products.join(","));
      try {
        let res = await this.$hyperRemote.getData({
          e: {
            params: [
              {
                value: this.article.products.join(","),
                build: this.article.products.join(","),
                key: "barcodes",
              },
            ],
          },
          cookies: this.$cookies,
          app: this,
          urlOnly: false,
        });
        this.relatedProducts = res.data;
      } catch (error) {
        console.error(error);
      }
    },
    async getAdjacent(id) {
      try {
        let [previous, next] = (
          await this.$hyperBlog.getArticles(
            false,
            false,
            2,
            1,
            false,
            id,
            "title slug"
          )
        ).docs;
        if (previous) {
          this.previous = {
            url: `/blog/article/${previous.slug}`,
            title: previous.title,
            ready: true,
          };
        }
        if (next) {
          this.next = {
            url: `/blog/article/${next.slug}`,
            title: next.title,
            ready: true,
          };
        }
      } catch (error) {
        console.error(error);
      }
    },
    getLocation() {
      if (process.browser) {
        return window.location.href;
      }
    },
  },
};
